import type { MiraIconName } from '@mira/clients-shared';
import avatarDad from './reference/avatar-dad.png';
import avatarEmma from './reference/avatar-emma.png';
import avatarMichael from './reference/avatar-michael.png';
import avatarMira from './reference/avatar-mira.png';
import avatarSarah from './reference/avatar-sarah.png';
import avatarSophie from './reference/avatar-sophie.png';
import lakeHero from './reference/lake-hero.png';
import memoryBook from './reference/memory-book.png';
import memoryTea from './reference/memory-tea.png';
import notePhotoBook from './reference/note-photo-book.png';
import notePhotoPath from './reference/note-photo-path.png';
import notePhotoPlant from './reference/note-photo-plant.png';
import notePhotoTea from './reference/note-photo-tea.png';
import image2InsightIcon from './image2/icons/insight.png';
import image2LockIcon from './image2/icons/lock.png';
import image2MemoryIcon from './image2/icons/memory.png';
import image2NoteIcon from './image2/icons/note.png';
import image2RelationshipIcon from './image2/icons/relationship.png';
import image2SparkIcon from './image2/icons/spark.png';
import image2TodayIcon from './image2/icons/today.png';
import image2TopicIcon from './image2/icons/topic.png';

export const webReferenceAssets = {
  avatarDad,
  avatarEmma,
  avatarMichael,
  avatarMira,
  avatarSarah,
  avatarSophie,
  lakeHero,
  memoryBook,
  memoryTea,
  notePhotoBook,
  notePhotoPath,
  notePhotoPlant,
  notePhotoTea,
} as const;

export const webImage2IconAssetFiles = {
  'nav.today': 'today.png',
  'nav.topics': 'topic.png',
  'nav.relationships': 'relationship.png',
  'nav.memory': 'memory.png',
  'semantic.insight': 'insight.png',
  'semantic.lock': 'lock.png',
  'semantic.memory': 'memory.png',
  'semantic.note': 'note.png',
  'semantic.relationship': 'relationship.png',
  'semantic.spark': 'spark.png',
  'semantic.topic': 'topic.png',
} as const satisfies Partial<Record<MiraIconName, string>>;

export const webImage2IconAssets: Partial<Record<MiraIconName, string>> = {
  'nav.today': image2TodayIcon,
  'nav.topics': image2TopicIcon,
  'nav.relationships': image2RelationshipIcon,
  'nav.memory': image2MemoryIcon,
  'semantic.insight': image2InsightIcon,
  'semantic.lock': image2LockIcon,
  'semantic.memory': image2MemoryIcon,
  'semantic.note': image2NoteIcon,
  'semantic.relationship': image2RelationshipIcon,
  'semantic.spark': image2SparkIcon,
  'semantic.topic': image2TopicIcon,
};
